/* UNDENIABLE — product rails (scroll/drag/nav/progress) + one-tap size add-to-cart.
   Add-to-cart posts to /cart/add.js; undeniable-cart.js intercepts it and opens the drawer. */
(function () {
  'use strict';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var RM = window.matchMedia ? matchMedia('(prefers-reduced-motion:reduce)').matches : false;
  var $$ = function (s, c) { return [].slice.call((c || document).querySelectorAll(s)); };
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  /* ── one-tap add ── */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-add]');
    if (!b || b.classList.contains('out')) return;
    e.preventDefault();
    var id = b.getAttribute('data-add');
    if (!id) return;
    b.classList.add('on');
    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function () {
      setTimeout(function () { b.classList.remove('on'); }, 900);
    }).catch(function () { b.classList.remove('on'); });
  });

  /* ── cart cross-sell: variant dropdown re-targets the add button ── */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-xsvar]');
    if (!sel) return;
    var card = sel.closest('.xs'); if (!card) return;
    var addBtn = card.querySelector('.xs__add'); if (!addBtn) return;
    var opt = sel.options[sel.selectedIndex];
    var disabled = !!(opt && opt.disabled);
    addBtn.setAttribute('data-add', sel.value);
    addBtn.classList.toggle('out', disabled);
    addBtn.disabled = disabled;
  });

  /* ── product-card colour swatches: switch image + re-target the size row ── */
  document.addEventListener('click', function (e) {
    var cb = e.target.closest('.pc [data-pccolor]');
    if (!cb) return;
    var card = cb.closest('.pc'); if (!card) return;
    $$('[data-pccolor]', card).forEach(function (o) { o.classList.toggle('on', o === cb); });
    var color = cb.getAttribute('data-pccolor');
    var img = cb.getAttribute('data-img');
    if (img) { var main = card.querySelector('[data-pc-img]'); if (main) main.src = img; }
    var map = card.querySelector('[data-pc-map]');
    if (!map) return;
    var vs = $$('i', map);
    $$('.szrow [data-size]', card).forEach(function (btn) {
      var sz = btn.getAttribute('data-size'), vid = 0;
      for (var i = 0; i < vs.length; i++) {
        if (vs[i].getAttribute('data-c') === color && vs[i].getAttribute('data-s') === sz && vs[i].getAttribute('data-a') === 'true') { vid = vs[i].getAttribute('data-id'); break; }
      }
      if (vid) { btn.setAttribute('data-add', vid); btn.classList.remove('out'); btn.disabled = false; }
      else { btn.removeAttribute('data-add'); btn.classList.add('out'); btn.disabled = true; }
    });
  });

  /* ── The Set: size select + add all three ── */
  document.addEventListener('click', function (e) {
    var sb = e.target.closest('.setc [data-ssz]');
    if (sb && !sb.disabled) {
      var card = sb.closest('.setc');
      $$('[data-ssz]', card).forEach(function (o) { o.classList.remove('on'); });
      sb.classList.add('on');
      return;
    }
    var add = e.target.closest('[data-set-add]');
    if (!add) return;
    e.preventDefault();
    var set = add.closest('.set'); if (!set) return;
    var items = [];
    $$('.setc', set).forEach(function (c) {
      var sel = c.querySelector('[data-ssz].on') || c.querySelector('[data-vid]');
      var vid = sel && sel.getAttribute('data-vid');
      if (vid) items.push({ id: vid, quantity: 1 });
    });
    if (!items.length) return;
    add.classList.add('on');
    fetch(ROOT + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function () {
      var code = set.getAttribute('data-discount-code');
      if (code) { window.location.href = ROOT + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(ROOT + 'cart'); }
      setTimeout(function () { add.classList.remove('on'); }, 900);
    }).catch(function () { add.classList.remove('on'); });
  });

  /* ── Tabbed rail: chips switch collections ── */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-tabs] [data-tab]');
    if (!chip) return;
    var wrap = chip.closest('.wrap'); if (!wrap) return;
    var id = chip.getAttribute('data-tab');
    $$('[data-tabs] [data-tab]', wrap).forEach(function (c) { c.classList.toggle('on', c === chip); });
    $$('[data-panel]', wrap).forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== id; });
    var rail = wrap.querySelector('[data-panel="' + id + '"] .rail');
    if (rail) {
      $$('.rnav [data-rail]', wrap).forEach(function (b) { b.dataset.rail = rail.id; });
      if (rail._rstate) rail._rstate();
    }
  });

  /* ── Complete the set (FBT): toggle rows, recompute totals, add selected ── */
  function fbtMoney(cents, format) {
    format = format || '${{amount}}';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    var no = /no_decimals/.test((format.match(re) || [])[1] || '');
    var v = (cents / 100).toFixed(no ? 0 : 2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format.replace(re, v);
  }
  function fbtRecompute(fbt) {
    if (!fbt) return;
    var pct = parseFloat(fbt.getAttribute('data-pct')) || 0;
    var fmt = fbt.getAttribute('data-money-format') || '${{amount}}';
    var sum = 0, count = 0;
    $$('[data-fbt-it]', fbt).forEach(function (it) {
      if (it.classList.contains('on')) { sum += parseInt(it.getAttribute('data-price'), 10) || 0; count++; }
    });
    var saving = Math.round(sum * pct / 100), total = sum - saving;
    var setTxt = function (sel, val) { var el = fbt.querySelector(sel); if (el) el.textContent = val; };
    setTxt('[data-fbt-count]', count);
    setTxt('[data-fbt-sub]', fbtMoney(sum, fmt));
    setTxt('[data-fbt-save]', '−' + fbtMoney(saving, fmt));
    setTxt('[data-fbt-tot]', fbtMoney(total, fmt));
  }
  document.addEventListener('click', function (e) {
    var it = e.target.closest('.fbt [data-fbt-it]');
    if (it) { it.classList.toggle('on'); fbtRecompute(it.closest('.fbt')); return; }
    var add = e.target.closest('[data-fbt-add]');
    if (!add) return;
    e.preventDefault();
    var fbt = add.closest('.fbt'); if (!fbt) return;
    var items = [];
    $$('[data-fbt-it].on', fbt).forEach(function (i) {
      var vid = i.getAttribute('data-vid');
      if (vid && vid !== '0') items.push({ id: vid, quantity: 1 });
    });
    if (!items.length) return;
    add.classList.add('on');
    fetch(ROOT + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function () {
      var code = fbt.getAttribute('data-discount-code');
      if (code) { window.location.href = ROOT + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(ROOT + 'cart'); }
      setTimeout(function () { add.classList.remove('on'); }, 900);
    }).catch(function () { add.classList.remove('on'); });
  });

  /* ── rails ── */
  function initRail(t) {
    var id = t.id;
    function rstate() {
      var max = t.scrollWidth - t.clientWidth;
      var bar = document.querySelector('[data-bar="' + id + '"]');
      if (bar) bar.style.transform = 'scaleX(' + (max <= 1 ? 1 : clamp((t.scrollLeft + t.clientWidth) / t.scrollWidth, 0.06, 1)) + ')';
      $$('[data-rail="' + id + '"]').forEach(function (btn) {
        var d = +btn.dataset.dir;
        btn.disabled = max <= 1 || (d < 0 ? t.scrollLeft <= 2 : t.scrollLeft >= max - 2);
      });
    }
    t.addEventListener('scroll', rstate, { passive: true });
    /* pointer drag */
    var down = false, sx = 0, sl = 0, moved = 0;
    t.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch' || e.target.closest('button,a')) return;
      down = true; moved = 0; sx = e.clientX; sl = t.scrollLeft;
    });
    addEventListener('pointerup', function () {
      if (down && moved > 6) t.dataset.drag = 1;
      down = false; t.classList.remove('drag');
      setTimeout(function () { delete t.dataset.drag; }, 40);
    });
    t.addEventListener('pointermove', function (e) {
      if (!down) return;
      moved = Math.abs(e.clientX - sx);
      if (moved > 4) t.classList.add('drag');
      t.scrollLeft = sl - (e.clientX - sx);
    });
    /* horizontal wheel */
    t.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      var max = t.scrollWidth - t.clientWidth;
      if (max <= 1) return;
      if ((e.deltaX < 0 && t.scrollLeft <= 0) || (e.deltaX > 0 && t.scrollLeft >= max)) return;
      e.preventDefault(); t.scrollLeft += e.deltaX;
    }, { passive: false });
    rstate();
    t._rstate = rstate;
  }

  function boot() {
    $$('.rail').forEach(initRail);
    $$('[data-rail]').forEach(function (b) {
      b.addEventListener('click', function () {
        var t = document.getElementById(b.dataset.rail);
        if (!t) return;
        var c = t.querySelector('.pc');
        var step = (c ? c.offsetWidth + 16 : 280) * (innerWidth > 900 ? 2 : 1);
        t.scrollBy({ left: step * (+b.dataset.dir), behavior: RM ? 'auto' : 'smooth' });
        setTimeout(function () { if (t._rstate) t._rstate(); }, 420);
      });
    });
    function remeasure() { $$('.rail').forEach(function (t) { if (t._rstate) t._rstate(); }); }
    addEventListener('resize', remeasure);
    [120, 400, 1200].forEach(function (ms) { setTimeout(remeasure, ms); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(remeasure);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
